import MdcContentSaveMoveOutline from '@meronex/icons/mdc/MdcContentSaveMoveOutline';
import icon from './StyledIcon';
export default icon(MdcContentSaveMoveOutline);
